import Link from 'next/link';
import { PureComponent } from 'react';
import styled, { ThemeProvider } from 'styled-components';
import { Button, ButtonSizes } from '../../../../shared/styles/button';
import { device } from '../../../../shared/styles/device';
import { AgenturImage } from '../../components/global/authentication/Register/agenturImage';
import { TalentImage } from '../../components/global/authentication/Register/talentImage';
import Seo from '../../components/global/Seo';
import { theme } from '../../styles/theme';



const RegisterGrid = styled.div`
  display: grid;
  max-height: 100vh;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  grid-template-rows: 100vh;
`;

const RegisterColumn = styled.div`
  display: flex;
  position: relative;
  padding: 12px;

  @media ${device.tablet} {
    padding: 50px;
  }
`;

const RegisterOverlay = styled.div`
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  margin-top: auto;
  border-radius: 25px;
  background-color: rgba(0,0,0,0.45);
  backdrop-filter: blur(45px);
  padding: 10px;
  box-sizing: border-box;

   h1 {
      margin: 0;
      color: #FFFFFF;
      font-style: normal;
      font-weight: 700;
      font-size: 15px;
      line-height: normal;
      text-align: center;
      margin-bottom: 16px;
   }

  @media ${device.tablet} {
    padding: 45px 53px 79px 53px;

    h1 {
      margin: 0;
      font-weight: 800;
      font-size: 36px;
      line-height: 52px;
      text-align: center;
      margin-bottom: 32px;

      span {
        color: ${(props) => props.theme.colors.primary};
      }
    }
  }
`;

const ButtonMobile = styled.div`
  visibility: visible;
  display: flex;
  
  @media ${device.tablet} {
    display: none;
    visibility: hidden;
  }
`;
const ButtonDesktop = styled.div`
  display: none;
  visibility: hidden;
  
  @media ${device.tablet} {
    visibility: visible;
    display: flex;
  }
`;

const initialState = {
  username: ``,
  password: ``,
  email: '',
  phone_number: '',
  authCode: '',
  stage: 0,
  error: '',
  user_group: 'Talente',
}

export default class RegisterPage extends PureComponent {
  state = initialState

  render() {
    const title = 'Registrierung';
    const description = 'Registrierung für den easyboarding Talentpool.';


    return (
      <ThemeProvider theme={theme}>
        <Seo title={title} description={description} />
        <section className="section-register">
          <RegisterGrid>
            <RegisterColumn>
              <RegisterOverlay>
                <h1>Als <span>Unternehmen</span> registrieren und exklusiven Zugang zum Talentpool erhalten</h1>
                <ButtonDesktop>
                  <Link href="/talentpool/arbeitgeber#contact">
                    <Button primary type="button" size={ButtonSizes.l}>Als Unternehmen registrieren</Button>
                  </Link>
                </ButtonDesktop>
                <ButtonMobile>
                  <Link href="/talentpool/arbeitgeber#contact">
                    <Button primary type="button" size={ButtonSizes.s}>Als Unternehmen registrieren</Button>
                  </Link>
                </ButtonMobile>
              </RegisterOverlay>
              <AgenturImage></AgenturImage>
            </RegisterColumn>
            <RegisterColumn>
              <RegisterOverlay>
                <h1>Als <span>Talent</span> bewerben und mit den angesehensten Unternehmen connecten</h1>
                <ButtonDesktop>
                  <Link href="/register/talent">
                    <Button primary type="button" size={ButtonSizes.l}>Als Talent bewerben</Button>
                  </Link>
                </ButtonDesktop>

                <ButtonMobile>
                  <Link href="/register/talent">
                    <Button primary type="button" size={ButtonSizes.s}>Als Talent bewerben</Button>
                  </Link>
                </ButtonMobile>
              </RegisterOverlay>
              <TalentImage></TalentImage>
            </RegisterColumn>
          </RegisterGrid>
        </section>
      </ThemeProvider>
    );
  }
}